import styled from 'styled-components';
import { NewRow as InsertNewRow } from 'components/molecules/new-row';

export const MoreActions = styled.div`
  display: flex;
  align-items: center;
  opacity: 0;
  transition: opacity var(--animation-duration-fast) ease-in;
  padding: var(--spacing-02) var(--spacing-03);
  position: absolute;
  right: 0;
  background: var(--coolest-gray-10);
  top: -2px;

  button {
    width: 20px;
    height: 20px;

    + button {
      margin-left: var(--spacing-03);
    }
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex: 1;

  .icon-shell {
    margin-right: var(--spacing-03);
    min-width: 32px;
    padding-top: 2px;
  }
`;

export const NewRow = styled(InsertNewRow)`
  width: 100%;

  .ant-input,
  .icon-shell {
    background: transparent;
    height: var(--input-size-xs);
  }
`;

export const NewPhaseRow = styled(NewRow)`
  .icon-shell svg {
    margin-left: -8px;
  }
`;

export const Title = styled.span`
  padding-top: 2px;
`;
